import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ChapterViewLayer from "../components/ChapterViewLayer";

const ChapterViewPage = () => {
    return (
        <>
            <MasterLayout>
                <ChapterViewLayer />
            </MasterLayout>
        </>
    );
};

export default ChapterViewPage;
